import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import ForumIcon from '@mui/icons-material/Forum'; // A suitable icon for "Happy Clients"
import whyChooseUsImage from "../../../assets/chooseus.jpg"; // Update with your image path

const ChooseUs = () => {
    return (
        // Use a white background as per the new design
        <Box sx={{ py: 10, backgroundColor: "#fff" }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">

                    {/* Left Side - Image with Overlay */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                            <Box
                                component="img"
                                src={whyChooseUsImage} // Using the new image
                                alt="On-site installation with insulation and a hard hat"
                                sx={{
                                    width: "100%",
                                    borderRadius: '16px', // Rounded corners for the image
                                    display: 'block', // Removes extra space below the image
                                }}
                            />
                            {/* Green Overlay Box */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: { xs: 16, md: 24 },
                                    left: { xs: 16, md: 24 },
                                    backgroundColor: '#65d78a', // Using the same green as the hero section
                                    color: 'white',
                                    p: 2,
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                }}
                            >
                                <ForumIcon sx={{ fontSize: { xs: 30, md: 40 } }} />
                                <Box>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' }, lineHeight: 1 }}>
                                        98%
                                    </Typography>
                                    <Typography sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' } }}>
                                        Happy Clients
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Right Side - Text Content */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontWeight: "bold",
                                color: "#27373b", // Using the dark color from the hero section
                                mb: 3
                            }}
                        >
                            Why choose us?
                        </Typography>

                        <Typography variant="body1" sx={{ color: "#555", fontSize: '1.1rem', lineHeight: 1.7, mb: 2 }}>
                            From on-site installation to full compliance documentation, we ensure every project is properly staffed, fully compliant, and audit-ready.
                        </Typography>

                        <Typography variant="body1" sx={{ color: "#555", fontSize: '1.1rem', lineHeight: 1.7 }}>
                            Whether you’re an energy supplier, principal contractor, or lead generator, we bring the expertise to manage both delivery and regulation—supported by PAS 2030/2035, TrustMark, and MCS accreditations.
                        </Typography>
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
};

export default ChooseUs;